import { render, staticRenderFns } from "./DepartmentTreeForUser.vue?vue&type=template&id=3e01709d&scoped=true"
import script from "./DepartmentTreeForUser.vue?vue&type=script&lang=js"
export * from "./DepartmentTreeForUser.vue?vue&type=script&lang=js"
import style0 from "./DepartmentTreeForUser.vue?vue&type=style&index=0&id=3e01709d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e01709d",
  null
  
)

export default component.exports